import React from 'react';

interface Platform {
  platform: string;
  username?: string;
  pageName?: string;
  pageId?: string;
}

interface PlatformConnectionsProps {
  platforms?: Platform[];
}

const PLATFORM_ICONS: Record<string, string> = {
  facebook: '🔵',
  instagram: '🟣',
  twitter: '🔷',
  linkedin: '🔹',
  pinterest: '🔴',
  youtube: '🔺',
  tiktok: '⬛',
  threads: '⚫',
  google_my_business: '🟢',
};

const PLATFORM_LABELS: Record<string, string> = {
  facebook: 'Facebook',
  instagram: 'Instagram',
  twitter: 'Twitter',
  linkedin: 'LinkedIn',
  pinterest: 'Pinterest',
  youtube: 'YouTube',
  tiktok: 'TikTok',
  threads: 'Threads',
  google_my_business: 'Google My Business',
};

export function PlatformConnections({ platforms }: PlatformConnectionsProps) {
  if (!platforms || platforms.length === 0) {
    return null;
  }

  return (
    <div className="py-6 border-b border-border">
      <h3 className="text-sm font-semibold text-foreground mb-4">Social Media Platforms</h3>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {platforms.map((platform, index) => {
          const icon = PLATFORM_ICONS[platform.platform] || '📱';
          const label = PLATFORM_LABELS[platform.platform] || platform.platform;

          return (
            <div
              key={index}
              className="flex items-center gap-3 p-3 bg-muted/50 rounded-lg border border-border hover:bg-muted transition-colors"
            >
              <span className="text-2xl">{icon}</span>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium text-foreground">
                  {label}
                </div>
                {platform.username && (
                  <div className="text-xs text-muted-foreground">
                    {platform.username}
                  </div>
                )}
                {platform.pageName && (
                  <div className="text-xs text-muted-foreground truncate">
                    {platform.pageName}
                  </div>
                )}
              </div>
              <div className="flex-shrink-0">
                <div className="w-2 h-2 rounded-full bg-green-500" title="Connected" />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
